// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/LexicalEditor/LexicalEditorTableUtils.jsx

import React from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $createTableNodeWithDimensions } from '@lexical/table';
import { $getRoot, $getSelection, $isRangeSelection, $createParagraphNode, createCommand } from 'lexical';
import { TableCellNode, TableNode, TableRowNode } from '@lexical/table';

export const INSERT_TABLE_COMMAND_CUSTOM = createCommand('INSERT_TABLE_COMMAND_CUSTOM');

const TablePlugin = () => {
  const [editor] = useLexicalComposerContext();

  React.useEffect(() => {
    if (!editor.hasNodes([TableNode, TableRowNode, TableCellNode])) {
      console.error('TablePlugin: Table nodes not registered.');
      return;
    }

    return editor.registerCommand(
      INSERT_TABLE_COMMAND_CUSTOM,
      (payload) => {
        const { rows, columns, includeHeaders } = payload;
        const numRows = parseInt(rows, 10);
        const numColumns = parseInt(columns, 10);

        if (isNaN(numRows) || isNaN(numColumns) || numRows <= 0 || numColumns <= 0) {
          console.error('Invalid table dimensions:', { rows, columns });
          return false;
        }

        console.log('INSERT_TABLE_COMMAND_CUSTOM called with payload:', payload);

        editor.update(() => {
          try {
            const tableNode = $createTableNodeWithDimensions(
              numRows,
              numColumns,
              includeHeaders
            );

            const paragraphNode = $createParagraphNode();
            paragraphNode.append(tableNode);

            const selection = $getSelection();
            const root = $getRoot();

            if ($isRangeSelection(selection)) {
              selection.insertNodes([paragraphNode], true);
              console.log('Table inserted at cursor position');
            } else {
              root.append(paragraphNode);
              console.log('Table inserted at the end of the editor');
            }

            const firstCell = tableNode.getFirstDescendant();
            if (firstCell && firstCell.isAttached() && typeof firstCell.selectStart === 'function') {
              firstCell.selectStart();
            } else {
              tableNode.selectEnd();
            }
          } catch (error) {
            console.error('Error inserting table:', error);
            return false;
          }
        });
        return true;
      },
      0
    );
  }, [editor]);

  return null;
};

export default TablePlugin;